import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { isSameMonth } from 'date-fns'
import { setActiveDatesAction, setCurrentDateAction, setCurrentMonthAction } from 'reducks/calendar/actions'

const handleCurrentDate = (date: Date) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const currentMonth = getState().calendar.currentMonth
    // 月またぎであれば更新
    if (!isSameMonth(currentMonth, date)) dispatch(setCurrentMonthAction(date))
    dispatch(setCurrentDateAction(date))
    dispatch(setActiveDatesAction([date]))
  }
}

export default handleCurrentDate
